/** 当前打开的客户贺卡名称；null 表示没有贺卡。 */
import { atom, useRecoilState } from 'recoil';

// 3D 卡片点击时写入，Dom/Header/LetterPopup 读取并据此切换界面。
const activeLetterState = atom<string | null>({
    key: 'activeLetterState',
    default: null,
});

/** 统一导出 hook，调用方式与 React.useState 相同：[value, setValue]。 */
export const useActiveLetterState = () => useRecoilState(activeLetterState);
